import {
  $assignment,
  $date,
  $defaultFrequency,
  $myCallsign,
  $view,
} from '@/stores';
import { useStore } from '@nanostores/react';

export default function LogBookHeader() {
  const view = useStore($view);
  const assignment = useStore($assignment);
  const date = useStore($date);
  const myCallsign = useStore($myCallsign);
  const defaultFrequency = useStore($defaultFrequency);

  if (view !== 'operator') {
    return (
      <tr className="border border-gray-600">
        <td colSpan={6}>
          <div
            id="logbook-header"
            className="flex items-center justify-between"
          >
            <div className="flex grow flex-col border-r border-gray-600">
              <label className="m-0.5 text-xs font-semibold">
                Assignment — Tâche
              </label>
              <div className="px-2 py-1">{assignment}</div>
            </div>
            <div className="flex flex-col border-r border-gray-600">
              <label className="m-0.5 text-xs font-semibold">Date</label>
              <div className="w-32 px-2 py-1">{date}</div>
            </div>
            <div className="flex flex-col">
              <label className="m-0.5 text-xs font-semibold">Station</label>
              <div className="w-24 px-2 py-1">{myCallsign}</div>
            </div>
          </div>
        </td>
      </tr>
    );
  }

  return (
    <tr className="sticky top-0 z-10 border border-b-0 border-gray-600 bg-white">
      <td colSpan={6}>
        <div id="logbook-header" className="flex items-center justify-between">
          <div
            className="flex grow flex-col border-r border-b border-gray-600"
            id="header-assignment"
          >
            <label className="m-0.5 text-xs font-semibold">
              Assignment — Tâche
            </label>
            <input
              type="text"
              value={assignment}
              onChange={e => $assignment.set(e.target.value)}
              className="px-2 py-1 print:hidden"
            />
            <div className="hidden px-2 py-1 print:block">{assignment}</div>
          </div>
          <div
            className="flex flex-col border-r border-b border-gray-600"
            id="header-date"
          >
            <label className="m-0.5 text-xs font-semibold">Date</label>
            <input
              type="date"
              value={date}
              onChange={e => $date.set(e.target.value)}
              className="w-32 px-2 py-1 print:hidden"
            />
            <div className="hidden w-32 px-2 py-1 print:block">{date}</div>
          </div>
          <div
            className="flex flex-col border-b border-gray-600 not-print:border-r"
            id="header-callsign"
          >
            <label className="m-0.5 text-xs font-semibold print:hidden">
              Call Sign
            </label>
            <label className="m-0.5 text-xs font-semibold not-print:hidden">
              Station
            </label>
            <input
              type="text"
              value={myCallsign}
              onChange={e => $myCallsign.set(e.target.value)}
              className="w-24 px-2 py-1 print:hidden"
            />
            <div className="hidden w-24 px-2 py-1 print:block">
              {myCallsign}
            </div>
          </div>
          <div
            className="flex flex-col border-b border-gray-600 print:hidden"
            id="header-frequency"
          >
            <label className="m-0.5 text-xs font-semibold">Default Freq.</label>
            <input
              type="text"
              value={defaultFrequency}
              onChange={e => $defaultFrequency.set(e.target.value)}
              className="w-24 px-2 py-1"
            />
          </div>
        </div>
      </td>
    </tr>
  );
}
